module.exports = __webpack_public_path__ + "static/tsn-grid-3-3d21218fd1b3a613202c61df9a90f9e5.jpg";